import Image from 'app/Components/Shared/Image/image';
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import SaleFooter from '../SaleFooter/SaleFooter';
import PopUp from '../../../Shared/Popup/PopUp';

import { goToPage, reportAnalytics, setIsSubmit, setIsValid, setSimActivationList } from '../saleBlockSlice';
import SimActivation from '../SimActivation/simActivation';

const SimActivationPage = (props) => {
  const [isDisplaySimNumberPopup, setIsDisplaySimNumberPopup] = useState(false);
  let flowType = props.flowType;
  const selectedProductsWithoutEsim = [...props.productsInfo.selectedProducts].filter((p) => {
    return !p.isEsim;
  });

  useEffect(() => { }, []);

  //page params
  let isDisplayFooter = true;
  let btnText = 'המשך';
  let currentPageFunction = handleSimActivationContinue;
  let totalPrice = props.totalPrice;
  let totalPriceOneTime = props.totalPriceOneTime;
  let priceText = 'לחודש';
  let formid = 'sale';
  //page params

  let currentPageHeadline = (
    <div className='page-headline-wrapper'>
      <h1 className='sale-title'> {props.configuration.welcomeText} </h1>
      <h1 className='sale-title-big'> שנחבר את הקו לסים? </h1>
      <h2 className='sale-title-small'>
        איפה רואים את המספר סים
        <a id='display-sim-number-popover' href='javascript:void(0)' className='question-icon' onClick={handleDisplaySimNumberPopup}></a>
      </h2>
      <PopUp showPopUp={isDisplaySimNumberPopup} onClose={() => handleCloseSimNumberPopup()} className='sim-number-popup'>
        <div className='sim-number-popup-wrapper'>
          <div className='title-wrapper'> תוכלו למצוא את מספר הסים בחלקו האחורי של הכרטיס שלכם </div>
          <div className='image-wrapper'>
            {' '}
            <Image src={require('../SimActivation/images/sim.png')} />{' '}
          </div>
        </div>
      </PopUp>
    </div>
  );

  let currentPageView = (
    <SimActivation products={selectedProductsWithoutEsim} onValid={handleSimActivationValidate} onSubmit={props.isSubmit} />
  );

  function handleSimActivationContinue() {
    props.setIsSubmit({ isSubmit: true });
  }

  function handleSimActivationValidate(valid) {
    props.setIsSubmit({ isSubmit: false });
    if (valid) {
      handleSimActivationContinueAfterValid();
    }
    props.setIsSubmit({ isSubmit: false });
  }

  function handleSimActivationContinueAfterValid() {
    const simActivationList = props._simActivationList;
    props.setSimActivationList(simActivationList);

    if (flowType == 'existsCustomer') {
      props.goToPage({ page: 'userAddressPage', percent: 42 });
    } else {
      props.goToPage({ page: 'addressFormPage', percent: 30 });
    }
  }

  function handleDisplaySimNumberPopup() {
    setIsDisplaySimNumberPopup(true);
  }
  function handleCloseSimNumberPopup() {
    setIsDisplaySimNumberPopup(false);
  }

  return (
    <div className='slideAnimation'>
      {currentPageHeadline}
      <div className='sale-page-content'>
        {currentPageView}
        <SaleFooter
          isDisplayFooter={isDisplayFooter}
          btnText={btnText}
          onclick={currentPageFunction}
          price={totalPrice}
          totalPriceOneTime={totalPriceOneTime}
          priceText={priceText}
          formid={formid}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    saleType: state.saleBlock.saleType,
    flowType: state.saleBlock.flowType,
    page: state.saleBlock.page,
    percent: state.saleBlock.percent,
    progressBarPoints: state.saleBlock.progressBarPoints,
    configuration: state.saleBlock.epiServer.configuration,
    totalPrice: state.saleBlock.totalPrice,
    totalPriceOneTime: state.saleBlock.totalPriceOneTime,
    productsInfo: state.saleBlock.productsInfo,
    infrastructure: state.saleBlock.selectedAddress.infrastructure,
    saleBlock: state.saleBlock.epiServer.saleBlock,
    isSubmit: state.saleBlock.isSubmit,
    isValid: state.saleBlock.isValid,

    //other states
    _simActivationList: state.simActivation.simActivationList,
  };
};

const mapDispatchToProps = {
  goToPage,
  reportAnalytics,
  setIsSubmit,
  setIsValid,
  setSimActivationList,
};

export default connect(mapStateToProps, mapDispatchToProps)(SimActivationPage);
